module.exports = "https://images.shiksha.ws/saassets/media/Arrow-Gray.cd794b36.png";